import Enterprise from 'types/models/enterprise';

export enum SearchTypes {
  UserEnterpriseMembershipSearch
}

export type SearchState = {
  [SearchTypes.UserEnterpriseMembershipSearch]?: Enterprise[];
};
